const FreelancerUserPaymentMethodEnum = {
  Tipalti: 'Tipalti',
  AliPay: 'AliPay',
  BankTransfer: 'BankTransfer',
  PayPal: 'PayPal',
  Wise: 'Wise',
  WesternUnion: 'WesternUnion',
  PayNow: 'PayNow',
};

export default FreelancerUserPaymentMethodEnum;
